// import EFPicture from 'elem/compCommon/EFPicture';
import EcoImg from 'eco-design/base/eco-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';
import { calcEnergyGeneration, calcEnergyStorage, getRecommand } from '@/constants/off-grid';
import BestSelling from '@elem/compPage/CostSaving/components/D/BestSelling';
import { Scrollbar, Navigation } from 'swiper';
import { cloneDeep } from 'lodash';
import EFLight from '@elem/ui-assets/icons/appliances/EFLight';
import EFPhone from '@elem/ui-assets/icons/appliances/EFPhone';
import EFCarFridge from '@elem/ui-assets/icons/appliances/EFCarFridge';
import EFCoffeeMaker from '@elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFMicrowave from '@elem/ui-assets/icons/appliances/EFMicrowave';
import EFAirConditioner from '@elem/ui-assets/icons/appliances/EFAirConditioner';
import EFElectricBlanket from '@elem/ui-assets/icons/appliances/EFElectricBlanket';
import EFElectricGrill from '@elem/ui-assets/icons/appliances/EFElectricGrill';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';

export default function F_NA() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [open, setOpen] = useState(false);
    const [init1, setInit1] = useState(false);
    const [init2, setInit2] = useState(false);
    const [init3, setInit3] = useState(false);

    const SolarPanels: any = [
        {
            img: `/responsive/picture/common-products/110w.png`,
            quantity: 1,
            isActive: true,
            energy: 110,
            id: '110w',
            title: t('secF_card_110w'),
            cartTitle: t('secF_cart_110w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/160w.png`,
            quantity: 1,
            isActive: false,
            energy: 160,
            id: '160w',
            title: t('secF_card_160w'),
            cartTitle: t('secF_cart_160w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7003543044169',
                    ca: '8066687074458',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41682906218569',
                    ca: '52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/220w_bifacial.png`,
            quantity: 1,
            isActive: false,
            energy: 220,
            id: '220w',
            title: t('secF_card_220w'),
            cartTitle: t('secF_cart_220w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/400w.png`,
            quantity: 1,
            isActive: false,
            energy: 400,
            id: '400w',
            title: t('secF_card_400w'),
            cartTitle: t('secF_cart_400w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',
                    ca: '7287920001178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998021697609',
                    ca: '42092770263194',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/400w.png`,
            quantity: 1,
            isActive: false,
            energy: 800,
            id: '2*400w',
            title: t('secF_card_2*400w'),
            cartTitle: t('secF_cart_2*400w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',
                    ca: '7959022207130',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553987612745',
                    ca: '44031270322330',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/400w.png`,
            quantity: 1,
            isActive: false,
            energy: 500,
            id: '4*125w',
            title: t('secF_card_4*125w'),
            cartTitle: t('secF_cart_4*125w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7354152681545',
                    ca: '15030544531827',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41838060404809',
                    ca: '52317425009011',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/400w.png`,
            quantity: 1,
            isActive: false,
            energy: 220,
            id: '2*220w',
            title: t('secF_card_2*220w'),
            cartTitle: t('secF_cart_2*220w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553987547209',
                    ca: '52826518913395',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
    ];

    const iconMap: any = {
        Light: <EFLight />,
        Phone: <EFPhone />,
        CarFridge: <EFCarFridge />,
        CoffeeMaker: <EFCoffeeMaker />,
        MicroWave: <EFMicrowave />,
        AirConditioner: <EFAirConditioner />,
        ElectricBlanket: <EFElectricBlanket />,
        ElectricGrill: <EFElectricGrill />,
    };

    const [solarpanels, setSolarpanels] = useState([...SolarPanels]);

    const imgs: { [key: string]: string[] } = {
        dp3plus: [
            'https://websiteoss.ecoflow.com/upload/image/1755768208086/d3p_110w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768208280/d3p_160w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768208464/d3p_220w.png',
        ],
        delta2: [
            'https://websiteoss.ecoflow.com/upload/image/1755768206918/d2_110w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768207067/d2_160w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768207250/d2_220w.png',
        ],
        delta2max: [
            'https://websiteoss.ecoflow.com/upload/image/1755768207431/d2m_110w*2.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768207648/d2m_160w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768207839/d2x_220w.png',
        ],
        deltapro: [
            'https://websiteoss.ecoflow.com/upload/image/1755768208658/dp_220w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768208943/dp_400w.png',
        ],
        deltapro3: [
            'https://websiteoss.ecoflow.com/upload/image/1755768209170/dp3_220w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768209462/dp3_400w.png',
        ],
        delta3max: [
            'https://websiteoss.ecoflow.com/upload/image/1758944697651/d3m_220w.png',
            'https://websiteoss.ecoflow.com/upload/image/1758944697820/d3m_400w.png',
        ],
        delta3maxplus: [
            'https://websiteoss.ecoflow.com/upload/image/1758944790603/d3mp_220w.png',
            'https://websiteoss.ecoflow.com/upload/image/1758944790785/d3mp_400w.png',
        ],
        delta3ultraplus: [
            'https://websiteoss.ecoflow.com/upload/image/1758944854482/d3up_220w.png',
            'https://websiteoss.ecoflow.com/upload/image/1758944854659/d3up_400w.png',
        ],
        delta3ultra: [
            'https://websiteoss.ecoflow.com/upload/image/1758945029317/d3u_400w.png',
            'https://websiteoss.ecoflow.com/upload/image/1758945029095/d3u_2X400w.png',
            'https://websiteoss.ecoflow.com/upload/image/1758945028835/d3u_4X125w.png',
            'https://websiteoss.ecoflow.com/upload/image/1758945028586/d3u_2X220w.png',
        ],
    };

    const cards: any[] = [
        // {
        //     img: ``,
        //     power: t('secF_card4_power'),
        //     title: t('secF_card4_title'),
        //     id: 'dp3plus',
        //     tag: t('common_card_tag_hot_sale'),
        //     link_more: (() => {
        //         const localMap: any = {
        //             us: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826182496329',
        //             ca: 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station?variant=51645140926835',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     productId: (() => {
        //         const localMap: any = {
        //             us: '7289136054345',
        //             ca: '8331157766298',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     variantId: (() => {
        //         const localMap: any = {
        //             us: '41826182496329',
        //             ca: '51645140926835',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     descArr: ['secF_card4_desc1', 'secF_card4_desc2', 'secF_card4_desc3'],
        //     icons: [
        //         {
        //             icon: 'Light',
        //             title: 'secF_card4_icon1_title',
        //             desc: 'secF_card4_icon1_desc',
        //         },
        //         {
        //             icon: 'Phone',
        //             title: 'secF_card4_icon2_title',
        //             desc: 'secF_card4_icon2_desc',
        //         },
        //         {
        //             icon: 'CarFridge',
        //             title: 'secF_card4_icon3_title',
        //             desc: 'secF_card4_icon3_desc',
        //         },
        //         {
        //             icon: 'CoffeeMaker',
        //             title: 'secF_card4_icon4_title',
        //             desc: 'secF_card4_icon4_desc',
        //         },
        //         {
        //             icon: 'MicroWave',
        //             title: 'secF_card4_icon5_title',
        //             desc: 'secF_card4_icon5_desc',
        //         },
        //         {
        //             icon: 'AirConditioner',
        //             title: 'secF_card4_icon6_title',
        //             desc: 'secF_card4_icon6_desc',
        //         },
        //     ],
        //     children: JSON.parse(JSON.stringify([solarpanels[0], solarpanels[1], solarpanels[2]])),
        // },
        // {
        //     img: '/responsive/picture/common-products/delta2.png',
        //     power: t('secF_card1_power'),
        //     title: t('secF_card1_title'),
        //     id: 'delta2',
        //     link_more: (() => {
        //         const localMap: any = {
        //             us: 'https://us.ecoflow.com/products/delta-2-portable-power-station?variant=40569176326217',
        //             ca: 'https://ca.ecoflow.com/products/delta-2-portable-power-station?variant=43725896056986',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     productId: (() => {
        //         const localMap: any = {
        //             us: '6806217719881',
        //             ca: '7440912384154',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     variantId: (() => {
        //         const localMap: any = {
        //             us: '40569176326217',
        //             ca: '43725896056986',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     descArr: ['secF_card1_desc1', 'secF_card1_desc2', 'secF_card1_desc3'],
        //     icons: [
        //         {
        //             icon: 'Light',
        //             title: 'secF_card1_icon1_title',
        //             desc: 'secF_card1_icon1_desc',
        //         },
        //         {
        //             icon: 'Phone',
        //             title: 'secF_card1_icon2_title',
        //             desc: 'secF_card1_icon2_desc',
        //         },
        //         {
        //             icon: 'CarFridge',
        //             title: 'secF_card1_icon3_title',
        //             desc: 'secF_card1_icon3_desc',
        //         },
        //         {
        //             icon: 'CoffeeMaker',
        //             title: 'secF_card1_icon4_title',
        //             desc: 'secF_card1_icon4_desc',
        //         },
        //         {
        //             icon: 'MicroWave',
        //             title: 'secF_card1_icon5_title',
        //             desc: 'secF_card1_icon5_desc',
        //         },
        //         {
        //             icon: 'AirConditioner',
        //             title: 'secF_card1_icon6_title',
        //             desc: 'secF_card1_icon6_desc',
        //         },
        //     ],
        //     children: JSON.parse(JSON.stringify([solarpanels[0], solarpanels[1], solarpanels[2]])),
        // },
        // {
        //     img: `/responsive/picture/common-products/delta2max.png`,
        //     power: t('secF_card2_power'),
        //     title: t('secF_card2_title'),
        //     id: 'delta2max',
        //     tag: t('common_card_tag_hot_sale'),
        //     link_more: (() => {
        //         const localMap: any = {
        //             us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=54615943512137',
        //             ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=43592212775066',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     productId: (() => {
        //         const localMap: any = {
        //             us: '6905537888329',
        //             ca: '7825964400794',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     variantId: (() => {
        //         const localMap: any = {
        //             us: '54615943512137',
        //             ca: '43592212775066',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     descArr: ['secF_card2_desc1', 'secF_card2_desc2', 'secF_card2_desc3'],
        //     icons: [
        //         {
        //             icon: 'Light',
        //             title: 'secF_card2_icon1_title',
        //             desc: 'secF_card2_icon1_desc',
        //         },
        //         {
        //             icon: 'Phone',
        //             title: 'secF_card2_icon2_title',
        //             desc: 'secF_card2_icon2_desc',
        //         },
        //         {
        //             icon: 'CarFridge',
        //             title: 'secF_card2_icon3_title',
        //             desc: 'secF_card2_icon3_desc',
        //         },
        //         {
        //             icon: 'CoffeeMaker',
        //             title: 'secF_card2_icon4_title',
        //             desc: 'secF_card2_icon4_desc',
        //         },
        //         {
        //             icon: 'MicroWave',
        //             title: 'secF_card2_icon5_title',
        //             desc: 'secF_card2_icon5_desc',
        //         },
        //         {
        //             icon: 'AirConditioner',
        //             title: 'secF_card2_icon6_title',
        //             desc: 'secF_card2_icon6_desc',
        //         },
        //     ],
        //     children: JSON.parse(JSON.stringify([solarpanels[0], solarpanels[1], solarpanels[2]])),
        // },
        // {
        //     img: ``,
        //     power: t('secF_card5_power'),
        //     title: t('secF_card5_title'),
        //     id: 'deltapro',
        //     tag: t('common_card_tag_best_seller'),
        //     link_more: (() => {
        //         const localMap: any = {
        //             us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
        //             ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     productId: (() => {
        //         const localMap: any = {
        //             us: '6585086836809',
        //             ca: '6944959824026',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     variantId: (() => {
        //         const localMap: any = {
        //             us: '40516140138569',
        //             ca: '43725958873242',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     question: 'secF_card5_sub3_question',
        //     content: 'secF_card5_sub3_content',
        //     descArr: ['secF_card5_desc1', 'secF_card5_desc2', 'secF_card5_desc3'],
        //     icons: [
        //         {
        //             icon: 'Light',
        //             title: 'secF_card5_icon1_title',
        //             desc: 'secF_card5_icon1_desc',
        //         },
        //         {
        //             icon: 'CarFridge',
        //             title: 'secF_card5_icon2_title',
        //             desc: 'secF_card5_icon2_desc',
        //         },
        //         {
        //             icon: 'Phone',
        //             title: 'secF_card5_icon3_title',
        //             desc: 'secF_card5_icon3_desc',
        //         },
        //         {
        //             icon: 'ElectricBlanket',
        //             title: 'secF_card5_icon4_title',
        //             desc: 'secF_card5_icon4_desc',
        //         },
        //         {
        //             icon: 'ElectricGrill',
        //             title: 'secF_card5_icon5_title',
        //             desc: 'secF_card5_icon5_desc',
        //         },
        //         {
        //             icon: 'AirConditioner',
        //             title: 'secF_card5_icon6_title',
        //             desc: 'secF_card5_icon6_desc',
        //         },
        //     ],
        //     children: JSON.parse(JSON.stringify([{ ...solarpanels[2], isActive: true }, solarpanels[3]])),
        // },
        {
            img: ``,
            power: t('secF_card8_power'),
            title: t('secF_card8_title'),
            tag: t('common_card_tag_new_arrival'),
            id: 'delta3max',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873',
                    ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62060638372211',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386147061833',
                    ca: '15164532654451',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54692162764873',
                    ca: '62060638372211',
                };
                return localMap[locale] || localMap.us;
            })(),
            question: 'secF_card8_sub3_question',
            content: 'secF_card8_sub3_content',
            descArr: ['secF_card8_desc1', 'secF_card8_desc2', 'secF_card8_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secF_card8_icon1_title',
                    desc: 'secF_card8_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secF_card8_icon2_title',
                    desc: 'secF_card8_icon2_desc',
                },
                {
                    icon: 'CarFridge',
                    title: 'secF_card8_icon3_title',
                    desc: 'secF_card8_icon3_desc',
                },

                {
                    icon: 'CoffeeMaker',
                    title: 'secF_card8_icon4_title',
                    desc: 'secF_card8_icon4_desc',
                },
                {
                    icon: 'MicroWave',
                    title: 'secF_card8_icon5_title',
                    desc: 'secF_card8_icon5_desc',
                },
                {
                    icon: 'AirConditioner',
                    title: 'secF_card8_icon6_title',
                    desc: 'secF_card8_icon6_desc',
                },
            ],
            children: solarpanels.filter((item: any) => ['220w', '400w'].includes(item.id)),
        },
        {
            img: ``,
            power: t('secF_card9_power'),
            title: t('secF_card9_title'),
            tag: t('common_card_tag_new_arrival'),
            id: 'delta3maxplus',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
                    ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661618035',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386147061833',
                    ca: '15164532654451',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54718699962441',
                    ca: '62106661618035',
                };
                return localMap[locale] || localMap.us;
            })(),
            question: 'secF_card9_sub3_question',
            content: 'secF_card9_sub3_content',
            descArr: ['secF_card9_desc1', 'secF_card9_desc2', 'secF_card9_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secF_card9_icon1_title',
                    desc: 'secF_card9_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secF_card9_icon2_title',
                    desc: 'secF_card9_icon2_desc',
                },
                {
                    icon: 'CarFridge',
                    title: 'secF_card9_icon3_title',
                    desc: 'secF_card9_icon3_desc',
                },

                {
                    icon: 'CoffeeMaker',
                    title: 'secF_card9_icon4_title',
                    desc: 'secF_card9_icon4_desc',
                },
                {
                    icon: 'MicroWave',
                    title: 'secF_card9_icon5_title',
                    desc: 'secF_card9_icon5_desc',
                },
                {
                    icon: 'AirConditioner',
                    title: 'secF_card9_icon6_title',
                    desc: 'secF_card9_icon6_desc',
                },
            ],
            children: solarpanels.filter((item: any) => ['220w', '400w'].includes(item.id)),
        },
        {
            img: ``,
            power: t('secF_card10_power'),
            title: t('secF_card10_title'),
            id: 'delta3ultraplus',
            tag: t('common_card_tag_new_arrival'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713',
                    ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62106740556147',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386143096905',
                    ca: '15164531016051',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54718705008713',
                    ca: '62106740556147',
                };
                return localMap[locale] || localMap.us;
            })(),
            question: 'secF_card10_sub3_question',
            content: 'secF_card10_sub3_content',
            descArr: ['secF_card10_desc1', 'secF_card10_desc2', 'secF_card10_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secF_card10_icon1_title',
                    desc: 'secF_card10_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secF_card10_icon2_title',
                    desc: 'secF_card10_icon2_desc',
                },
                {
                    icon: 'CarFridge',
                    title: 'secF_card10_icon3_title',
                    desc: 'secF_card10_icon3_desc',
                },

                {
                    icon: 'CoffeeMaker',
                    title: 'secF_card10_icon4_title',
                    desc: 'secF_card10_icon4_desc',
                },
                {
                    icon: 'MicroWave',
                    title: 'secF_card10_icon5_title',
                    desc: 'secF_card10_icon5_desc',
                },
                {
                    icon: 'AirConditioner',
                    title: 'secF_card10_icon6_title',
                    desc: 'secF_card10_icon6_desc',
                },
            ],
            children: solarpanels.filter((item: any) => ['220w', '400w'].includes(item.id)),
        },
        {
            img: ``,
            power: t('secF_card11_power'),
            title: t('secF_card11_title'),
            id: 'delta3ultra',
            tag: t('common_card_tag_new_arrival'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692148871241',
                    ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62060629590387',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386143096905',
                    ca: '15164531016051',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54692148871241',
                    ca: '62060629590387',
                };
                return localMap[locale] || localMap.us;
            })(),
            question: 'secF_card11_sub3_question',
            content: 'secF_card11_sub3_content',
            descArr: ['secF_card11_desc1', 'secF_card11_desc2', 'secF_card11_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secF_card11_icon1_title',
                    desc: 'secF_card11_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secF_card11_icon2_title',
                    desc: 'secF_card11_icon2_desc',
                },
                {
                    icon: 'CarFridge',
                    title: 'secF_card11_icon3_title',
                    desc: 'secF_card11_icon3_desc',
                },

                {
                    icon: 'CoffeeMaker',
                    title: 'secF_card11_icon4_title',
                    desc: 'secF_card11_icon4_desc',
                },
                {
                    icon: 'MicroWave',
                    title: 'secF_card11_icon5_title',
                    desc: 'secF_card11_icon5_desc',
                },
                {
                    icon: 'AirConditioner',
                    title: 'secF_card11_icon6_title',
                    desc: 'secF_card11_icon6_desc',
                },
            ],
            children: solarpanels.filter((item: any) => ['400w', '4*125w', '2*220w'].includes(item.id)),
        },
        {
            img: ``,
            power: t('secF_card6_power'),
            title: t('secF_card6_title'),
            id: 'deltapro3',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7185477075017',
                    ca: '8231332380826',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            question: 'secF_card6_sub3_question',
            content: 'secF_card6_sub3_content',
            descArr: ['secF_card6_desc1', 'secF_card6_desc2', 'secF_card6_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secF_card6_icon1_title',
                    desc: 'secF_card6_icon1_desc',
                },
                {
                    icon: 'CarFridge',
                    title: 'secF_card6_icon2_title',
                    desc: 'secF_card6_icon2_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secF_card6_icon3_title',
                    desc: 'secF_card6_icon3_desc',
                },
                {
                    icon: 'ElectricBlanket',
                    title: 'secF_card6_icon4_title',
                    desc: 'secF_card6_icon4_desc',
                },
                {
                    icon: 'ElectricGrill',
                    title: 'secF_card6_icon5_title',
                    desc: 'secF_card6_icon5_desc',
                },
                {
                    icon: 'AirConditioner',
                    title: 'secF_card6_icon6_title',
                    desc: 'secF_card6_icon6_desc',
                },
            ],
            children: JSON.parse(JSON.stringify([{ ...solarpanels[2], isActive: true }, solarpanels[3]])),
        },
    ];

    const [cardLists, setCardLists] = useState([]);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('secF_title'),
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.price,
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy') || 'Buy Now',
            });
            // fb埋点
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const { price, compareAtPrice, inventoryPolicy, inventoryQuantity, productId, variantId, variantImg, img, productTitle, skuTitle, children } = card;
            const addCarts: ItfEcoCartItem[] = [
                {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    productTitle,
                    skuTitle,
                    quantity: 1,
                } as ItfEcoCartItem,
            ];
            const target = children?.find((item: any) => item?.isActive);

            if (target) {
                const {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    parentVariantId,
                    productTitle,
                    skuTitle,
                    quantity,
                } = target;
                addCarts.push({
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    parentVariantId,
                    productTitle,
                    skuTitle,
                    quantity,
                } as ItfEcoCartItem);
            }
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, addCarts);
        }
    };

    const handleClick = (_: any, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        const activeIdx = tempChildren.findIndex((item: any) => item.isActive);
        tempChildren[activeIdx].isActive = false;
        tempChildren[m].isActive = true;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCount = (_: any, num: number, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        tempChildren[m].quantity = num;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCalclate = (card: any, list: any) => {
        card.energy = calcEnergyGeneration(list?.energy, list?.quantity, locale);
        card.storage = calcEnergyStorage(card?.id);
    };

    const setSolarStatu = (item: any, child?: any) => {
        if (!child) {
            child = item?.children?.find((list: any) => list?.isActive);
        }
        if (!child?.recommand) {
            child.recommand = getRecommand(item.id, child.id);
        }
        item.statu = child?.quantity === 0 ? 0 : child.recommand?.includes(child?.quantity) ? 1 : 2;
    };

    const AddSubtractor = ({ data, callback, k, m }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventory ?? 1000;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.inventory < data?.quantity ? data?.inventory : data?.quantity ?? 1);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1, k, m);
        };

        const addNumber = () => {
            if (number >= NUM_MAX) return false;
            setNumber(number + 1);
            callback(data, number + 1, k, m);
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX || !Boolean(Number(v))) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v), k, m);
        };

        return (
            <div className="addSubtractor">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    -
                </div>
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    +
                </div>
            </div>
        );
    };

    const getAsynItem = async (item: any) => {
        const { productId, variantId, link_more } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    if (link_more && item?.children?.[0]) {
                        handleCalclate(item, item.children[0]);
                    }
                    if (res?.data?.handle) {
                        item.link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                    }
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;

                    return resolve({ ...item, ...res?.data });
                } else {
                    console.error(res?.message);
                    return reject({ ...item });
                }
            } catch (e) {
                console.error(e);
                return reject({ ...item });
            }
        });
    };

    useEffect(() => {
        const tempSolarPanelsArr = JSON.parse(JSON.stringify(solarpanels));
        const solarPromises = tempSolarPanelsArr?.map((item: any) => getAsynItem(item));
        Promise.all(solarPromises)
            .then((res: any) => {
                setSolarpanels(res);
                setInit1(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (init1) {
            const tempArr = JSON.parse(JSON.stringify(cards));

            const promises = tempArr?.map((item: any) => getAsynItem(item));
            Promise.all(promises)
                .then((res: any) => {
                    setCardLists(res);
                    setInit2(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [init1]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    useEffect(() => {
        if (init1 && init2) {
            const tempArr = JSON.parse(JSON.stringify([...cardLists]));
            tempArr?.map((item: any, _: number) => {
                if (!item?.children) return;
                item.children = cloneDeep(item.children.map((child: any) => solarpanels.find((_item: any) => _item.id === child.id))).filter(
                    (item: any) => !!item,
                );
                item.children.forEach((item: any) => (item.isActive = false));
                item.children[0].isActive = true;
                item?.children?.map((child: any) => {
                    child.cartTitle = `${child?.cartTitle} (${item?.title})`;
                    child.parentVariantId = item?.variantId;
                    child.recommand = item.id !== 'T200' && getRecommand(item?.id, String(child?.id));
                    if (Number(child?.inventoryQuantity || 0) < 0 && child?.inventoryPolicy !== 'continue') {
                        child.quantity = 0;
                    } else if (
                        child?.recommand?.length > 0 &&
                        (child?.inventoryPolicy === 'continue' ? 99 : Number(child?.inventoryQuantity || 0)) < child?.recommand[0]
                    ) {
                        child.quantity = child?.inventoryPolicy === 'continue' ? 99 : child?.inventoryQuantity;
                    } else {
                        child.quantity = child?.recommand?.length > 0 ? child?.recommand[0] : 0;
                    }
                });
                setSolarStatu(item, item?.children[0]);
                handleCalclate(item, item?.children[0]);
            });
            setCardLists(tempArr);
            setInit3(true);
        }
    }, [solarpanels, init1, init2]);

    return (
        <div id="vanlife-roadtrips-F" className={`outdoor-recreation-F outdoor-recreation-box inner ${css['outdoor-recreation-F']}`}>
            <h3 className="title">{t('secF_title')}</h3>
            <Swiper
                className="cards swiper-box"
                effect="fade"
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                modules={[Scrollbar, Navigation]}
                navigation
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cardLists?.map((card: any, k: number) => {
                    const isActiveChildIdx = card?.children?.findIndex((item: any) => item?.isActive);
                    return (
                        <SwiperSlide className={`card swiper-item item-${k + 1}`} key={k}>
                            <div className="main-product">
                                {card?.tag && <p className="card-tag">{card?.tag}</p>}
                                <div className="card-img">
                                    {/* <EFPicture src={imgs?.[card?.id]?.[isActiveChildIdx]} alt={card?.title} /> */}
                                    <EcoImg className="ef-picture" pc={imgs?.[card?.id]?.[isActiveChildIdx]} />
                                </div>
                                <div className="card-info">
                                    <p className="card-power">{card?.power}</p>
                                    <p className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                                    <ul className="card-descs">
                                        {card?.descArr?.map((desc: any, m: number) => (
                                            <li className="card-desc" key={`${k}_${m}`}>
                                                {t(desc)}
                                            </li>
                                        ))}
                                    </ul>
                                    {!open && (
                                        <span className="card-open" onClick={() => setOpen(true)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                                <path
                                                    d="M1.5 1L4.5 4L7.5 1"
                                                    stroke="#626262"
                                                    strokeWidth="1.21739"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                    )}
                                    {open && (
                                        <ul className="card-icons">
                                            {card?.icons?.map((item: any, m: number) => (
                                                <li className="card-icon" key={`${k}_${m}`}>
                                                    <span className="icon-svg">{iconMap[item?.icon]}</span>
                                                    <div className="icon-info">
                                                        <p className="icon-day">
                                                            {t.rich(item?.title, {
                                                                s: (text: string) => <span className="s">{text}</span>,
                                                            })}
                                                        </p>
                                                        <p className="icon-app">{t(item?.desc)}</p>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="sub-product">
                                <p className="sub-title">{t('common_card_calculator')}</p>
                                <div className={`sub-calc ${card?.statu === 2 ? 'not-recommand' : card?.statu === 0 ? 'zero' : ''}`}>
                                    <p className="calc-inner">
                                        {card?.statu === 0
                                            ? t.rich('common_card_0', {
                                                  storagePower: card?.storage,
                                                  s: (text: string) => <span className="s">{text}</span>,
                                              })
                                            : card?.statu === 2
                                            ? t('common_card_no_recommand')
                                            : t.rich('common_card_calculator_res', {
                                                  generatePower: card?.energy,
                                                  storagePower: card?.storage,
                                                  s: (text: string) => <span className="s">{text}</span>,
                                              })}
                                    </p>
                                </div>
                                <div className="solar-panel first">
                                    <span className="sp-text">{t('common_card_sp_output')}</span>
                                    <ul className="sp-products">
                                        {card?.children?.map((list: any, m: number) => (
                                            <li
                                                className={`output-list ${list?.isActive ? 'active' : ''} ${
                                                    card?.id === 'delta3ultra' ? 'output-list-width' : ''
                                                }`}
                                                key={`${k}_${m}`}
                                                onClick={() => handleClick(card, k, m)}
                                            >
                                                {list?.title}
                                                {['us', 'ca'].includes(locale) && list?.isBestSelling && <BestSelling className="best-selling" />}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="solar-panel">
                                    <span className="sp-text">{t('common_card_sp_quantity')}</span>
                                    <ul className="quantity-lists">
                                        {card?.children?.map((list: any, m: number) => (
                                            <li className={`quantity-list ${list?.isActive ? 'show' : 'hide'}`} key={`${k}_${m}`}>
                                                <AddSubtractor data={list} callback={handleCount} k={k} m={m} />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="card-btns">
                                {card?.link_buy && (
                                    <>
                                        {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? (
                                            <button disabled className={`btn-buy card-btn disable`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p className={`btn-buy card-btn`} onClick={() => init1 && init2 && init3 && handleBuy(card)}>
                                                {t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )}
                                {card?.link_more && (
                                    <Link
                                        className="btn-more card-btn"
                                        href={`${card?.link_more}${
                                            String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                        }utm_source=scenario+page&utm_medium=Pillar`}
                                        target="_blank"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'select_product',
                                            list_name: t('secF_title'),
                                            product_name: card.title,
                                            button_name: t('common_card_more'),
                                        }}
                                    >
                                        {t('common_card_more')}
                                    </Link>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
